import { Navigate } from "src/router";
import type { RouteObject } from "src/router";
import type { RoutePreload } from "src/router/route-preloads";
import { lazyNamed } from "src/utils/lazy-named";

import { DebuggerRoute } from "./debugger-route";
import { EventSourcePermissionsRoute } from "./event-source-permissions-route";

const CreateEventSource = lazyNamed(
  () => import("./create"),
  "CreateEventSource",
);
const eventSourcesImport = () => import("./sources");
const EventSources = lazyNamed(eventSourcesImport, "EventSources");

export const preloads: RoutePreload[] = [
  ["/events/sources", eventSourcesImport],
];
const Setup = lazyNamed(() => import("./source/setup"), "Setup");
const Configuration = lazyNamed(
  () => import("./source/configuration"),
  "Configuration",
);
const Overview = lazyNamed(() => import("./source/overview"), "Overview");
const EventCatalog = lazyNamed(
  () => import("./source/event-catalog"),
  "EventCatalog",
);
const ConfigureEvent = lazyNamed(
  () => import("./source/configure-event"),
  "ConfigureEvent",
);
const EventSourceLayout = lazyNamed(
  () => import("./source"),
  "EventSourceLayout",
);
const Alerting = lazyNamed(() => import("./source/alerting"), "Alerting");

export const routes: Array<RouteObject> = [
  {
    index: true,
    spacesAccess: "hidden-from-limited-view",
    element: <EventSources />,
  },
  {
    path: "new",
    spacesAccess: "hidden-from-limited-view",
    element: <CreateEventSource />,
  },
  {
    path: ":id",
    spacesAccess: "hidden-from-limited-view",
    element: <EventSourceLayout />,
    children: [
      {
        path: "overview",
        spacesAccess: "hidden-from-limited-view",
        element: <Overview />,
      },
      {
        path: "event-catalog",
        spacesAccess: "hidden-from-limited-view",
        element: <EventCatalog />,
        children: [
          {
            path: "configure/:eventId",
            spacesAccess: "hidden-from-limited-view",
            element: <ConfigureEvent />,
          },
        ],
      },
      {
        path: "debugger",
        spacesAccess: "hidden-from-limited-view",
        element: <DebuggerRoute />,
      },
      {
        path: "setup",
        spacesAccess: "hidden-from-limited-view",
        element: <Setup />,
      },
      {
        path: "configuration",
        spacesAccess: "hidden-from-limited-view",
        element: <Configuration />,
      },
      {
        path: "alerting",
        spacesAccess: "hidden-from-limited-view",
        element: <Alerting />,
      },
      {
        path: "permissions",
        spacesAccess: "hidden-from-limited-view",
        element: <EventSourcePermissionsRoute />,
      },
      {
        index: true,
        spacesAccess: "hidden-from-limited-view",
        element: (
          <Navigate
            to={{ pathname: "overview", search: location.search }}
            replace
          />
        ),
      },
    ],
  },
];
